import { render, staticRenderFns } from "./extBtn.vue?vue&type=template&id=3738492e&scoped=true&"
import script from "./extBtn.vue?vue&type=script&lang=js&"
export * from "./extBtn.vue?vue&type=script&lang=js&"
import style0 from "./extBtn.vue?vue&type=style&index=0&id=3738492e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3738492e",
  null
  
)

/* custom blocks */
import block0 from "./extBtn.vue?vue&type=custom&index=0&blockType=comment"
if (typeof block0 === 'function') block0(component)

export default component.exports